import axios from "axios"
// defaulty dla axiosa
function getCsrfToken() {
  const meta = document.querySelector("meta[name=\"csrf-token\"]")
  return meta && meta.getAttribute("content")
}
axios.defaults.headers.common["X-CSRF-Token"] = getCsrfToken()
